const Points = {
  Points: 'Points',
  addPoints: 'Add Points',
  editPoints: 'Edit Points',
};
export default Points;
